import NewLayout from "@components/new-ui/Layout";
import React from "react";
import { CasestudyCard, casestudyCards } from ".";
import { CaseStudyHerosection, CaseStudyInformation, ClientFeedback, FeatureList, Navbar, navLinks, OrganizationProfile } from "./alrannan-administrative-services";
import StatsInfo from "@components/new-ui/IndustriesSection/StatsInfo";

const Pickyourtrail: React.FC = () => {
    return (
        <NewLayout
            title="Pickyourtrail | WhatsApp Business customer story"
            description="Discover how Pickyourtrail revolutionized their WhatsApp marketing campaigns and streamlined customer communication for travel using Gallabox's innovative solutions."
            canonical="https://gallabox.com/case-study/pickyourtrail"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/case-study/pickyourtrail-og.png" }}
        >
            <CaseStudyHerosection
                title="Gallabox powers Pickyourtrail's WhatsApp marketing success"
                description="Discover how Pickyourtrail revolutionized their WhatsApp marketing campaigns for travel packages and streamlined vital business communication using Gallabox's innovative solutions."
                imageUrl={"https://assets.gallabox.com/gb-home/case-study/pickyourtrail.png"}
                redirectUrl={"/case-study"}
            />
            <StatsInfo
                statsInfo={[
                    { percentage: "77%", label: "Increase in lead generation" },
                    { percentage: "70%", label: "Business growth impact" },
                    { percentage: "40%", label: "Higher team productivity" },
                ]}
            />

            <section className="max-w-7xl mx-auto  md:grid md:grid-cols-6 mt-24 mb-24">
                <div className="bg-white col-span-1">
                    <div style={{ position: "sticky", top: "100px" }}>
                        <OrganizationProfile
                            companyProfileData={[
                                { label: "Company", value: ["Pickyourtrail"] },
                                { label: "Industry", value: ["Travel"] },
                                { label: "Employees", value: ["250-500"] },
                                { label: "Team", value: ["Sales", "Support", "Marketing"] },
                            ]}
                            product={{
                                title: "Features Used",
                                productLink: [
                                    { link: "https://gallabox.com/whatsapp-broadcast", label: "Broadcast" },
                                    { link: "https://gallabox.com/whatsapp-flows", label: "Flows" },
                                    { link: "https://gallabox.com/whatsapp-chatbot", label: "Chatbots" },
                                    { link: "https://gallabox.com/click-to-whatsapp-ads", label: "Click-to-WhatsApp Ads" },
                                    { link: "https://gallabox.com/whatsapp-integrations", label: "Integrations" },
                                ],
                            }}
                        />
                    </div>
                </div>
                <div className=" col-span-4 md:pl-8 px-4">
                    <div className="flex flex-col gap-y-12 ">
                        <section id="About">
                            <CaseStudyInformation mainTitle={"Pickyourtrail is where travel dreams meet digital innovation"} className="mt-0" />
                            <p className="mt-2">
                                <a href="https://pickyourtrail.com" className="text-blue-500">
                                    Pickyourtrail
                                </a>{" "}
                                is a renowned DIY holiday booking platform, offering tailored traveling experiences to all kinds of travel customers from leisure to adventure. As a
                                digital-first company, they recognized the importance of meeting customers where they are—on WhatsApp. However, their journey to effectively
                                leverage this channel wasn&apos;t without its challenges.
                            </p>
                        </section>

                        <section id="Challenges">
                            <CaseStudyInformation
                                subTitle={"Traditional WhatsApp marketing is a challenge when you scale "}
                                descriptions={["As a growing travel platform, Pickyourtrail faced several hurdles in their WhatsApp marketing efforts:"]}
                                className="mt-0"
                            />
                            <FeatureList
                                List={[
                                    { listItem: "Limited reach with traditional broadcast messages" },
                                    { listItem: "API integration issues with existing marketing automation tools" },
                                    { listItem: "Ineffective targeting of their audience on WhatsApp" },
                                    { listItem: "Challenges in scaling their WhatsApp campaigns." },
                                ]}
                                className="mt-4 bg-gray-100"
                            />
                            <p className="mt-5">
                                &quot;We faced challenges in running WhatsApp campaigns for our brand. As this is a trending marketing channel, we struggled to effectively target
                                our audience on WhatsApp,&quot; explains Meena, Senior CRM Associate from Pickyourtrail, highlighting their initial struggles.
                                <br />
                                <br />
                                Before finding their perfect match with Gallabox, Pickyourtrail:
                            </p>

                            <FeatureList
                                List={[
                                    { listItem: "Relied on basic WhatsApp Business broadcast with limited reach" },
                                    { listItem: "Experimented with alternative WhatsApp API services" },
                                    {
                                        listItem: "Evaluated Freshworks products for WhatsApp integration",
                                    },
                                    {
                                        listItem: "Struggled with API mismatches affecting their marketing automation.",
                                    },
                                ]}
                                className="mt-4 bg-gray-100"
                            />
                        </section>

                        <section id="Solutions">
                            <CaseStudyInformation
                                subTitle={"Why Gallabox emerged as the clear winner"}
                                descriptions={["The decision to implement Gallabox was driven by three key factors:"]}
                                className="mt-0"
                            />
                            <CaseStudyInformation subTitle={"User-friendly interface"} className="mt-10" />
                            <FeatureList
                                List={[
                                    { listItem: "Intuitive platform design" },
                                    { listItem: "Easy adoption by team members" },
                                    {
                                        listItem: "Minimal learning curve.",
                                    },
                                ]}
                                className="mt-4 bg-gray-100"
                            />
                            <CaseStudyInformation subTitle={"Flexible customization"} className="mt-10" />
                            <FeatureList
                                List={[
                                    { listItem: "Seamless integration with existing marketing automation tools" },
                                    { listItem: "Adaptable to specific business needs" },
                                    {
                                        listItem: "Customizable workflow options.",
                                    },
                                ]}
                                className="mt-4 bg-gray-100"
                            />
                            <CaseStudyInformation subTitle={"Superior support system"} className="mt-10" />
                            <FeatureList
                                List={[
                                    { listItem: "Responsive support team" },
                                    { listItem: "Dedicated assistance from day one" },
                                    {
                                        listItem: "Special mention of exceptional support from Yogesh, a Co-Founder of Gallabox.",
                                    },
                                ]}
                                className="mt-4 bg-gray-100"
                            />
                        </section>
                        <section>
                            <CaseStudyInformation
                                subTitle={"Transforming WhatsApp marketing with Gallabox"}
                                descriptions={[
                                    "The integration of Gallabox changed how Pickyourtrail connects with their travel enthusiasts. Their journey of transformation can be traced across multiple touchpoints:",
                                ]}
                                className="mt-0"
                            />

                            <CaseStudyInformation subTitle={"Breaking through broadcast limitations"} className="mt-10" />
                            <p className="mt-2">
                                When traditional broadcast messages weren&apos;t cutting it, Pickyourtrail leveraged Gallabox&apos;s broadcast capabilities to reach a wider
                                audience. &quot;Our previous broadcasting attempts only reached a limited number of leads,&quot; recalls Meena. &quot;With Gallabox&apos;s broadcast
                                feature, we&apos;re now able to engage with our entire customer base effectively, sharing tailored travel deals and destination updates that
                                actually reach our audience.&quot;
                            </p>
                            <CaseStudyInformation
                                subTitle={"Letting chatbots do the heavy lifting"}
                                descriptions={[
                                    "Pickyourtrail deployed intelligent chatbots that handle initial inquiries 24/7, ensuring that no potential traveler is left waiting. These bots don't just respond—they qualify leads and gather essential information, making every subsequent human interaction more meaningful and conversion-focused.",
                                ]}
                                className="mt-10"
                            />
                            <CaseStudyInformation
                                subTitle={"Crafting customer journeys with automated flows"}
                                descriptions={[
                                    "Pickyourtrail designed automated flows that guide customers from initial interest to final booking. When a customer expresses interest in a destination, the flow automatically shares relevant packages, travel tips, and seasonal recommendations, nurturing the lead with perfectly timed information.",
                                ]}
                                className="mt-10"
                            />
                            <CaseStudyInformation
                                subTitle={"Converting interest into conversations"}
                                descriptions={[
                                    "Click-to-WhatsApp ads transformed how Pickyourtrail captures leads. Instead of hoping customers would find their way to a contact form, these ads create instant connections. When travelers see an attractive holiday package on social media, they're just one click away from starting a conversation.",
                                ]}
                                className="mt-10"
                            />
                            <CaseStudyInformation
                                subTitle={"Building a connected ecosystem"}
                                descriptions={[
                                    "Every customer interaction, preference, and touchpoint is captured and synchronized, enabling their team to provide personalized travel recommendations based on comprehensive customer data.",
                                ]}
                                className="mt-10"
                            />

                            <ClientFeedback
                                descriptions={
                                    <p className="text-gray-900 italic font-semibold px-6 mb-4">
                                        With Gallabox&apos;s broadcast feature, we&apos;re now able to engage with our entire customer base effectively, sharing tailored travel
                                        deals and destination updates that actually reach our audience.
                                    </p>
                                }
                                authorName="Meena"
                                designationWithServiceName="Senior CRM Associate, Pickyourtrail"
                                className="border-blue-500 bg-blue-100 mt-4"
                            />
                        </section>

                        <section id="Impact">
                            <CaseStudyInformation
                                subTitle={"The impact numbers tell a story of smart WhatsApp Business adoption"}
                                descriptions={["The implementation of Gallabox brought significant and tangible improvements through their WhatsApp-led travel communication:"]}
                                className="mt-0"
                            />

                            <CaseStudyInformation subTitle={"77% boost in lead generation"} className="mt-10" />

                            <FeatureList
                                List={[
                                    { listItem: "Expanded reach through WhatsApp campaigns" },
                                    { listItem: "Enhanced lead capture mechanisms" },
                                    { listItem: "Improved targeting capabilities." },
                                ]}
                                className="mt-4 bg-gray-100"
                            />

                            <CaseStudyInformation subTitle={"70% impact on business growth"} className="mt-10" />

                            <FeatureList
                                List={[
                                    { listItem: "Expanded reach through WhatsApp campaigns" },
                                    { listItem: "Enhanced lead capture mechanisms" },
                                    { listItem: "Improved targeting capabilities." },
                                ]}
                                className="mt-4 bg-gray-100"
                            />

                            <CaseStudyInformation subTitle={"40% increase in team productivity"} className="mt-10" />
                            <FeatureList
                                List={[{ listItem: "Automated routine tasks" }, { listItem: "Efficient workflow management" }, { listItem: "Better resource utilization." }]}
                                className="mt-4 bg-gray-100"
                            />
                        </section>
                        <section>
                            <CaseStudyInformation
                                mainTitle={"What's next for Pickyourtrail"}
                                descriptions={["With Gallabox as their WhatsApp marketing partner, Pickyourtrail continues to:"]}
                                className="mt-0"
                            />
                            <FeatureList
                                List={[
                                    { listItem: "Generate and nurture leads more effectively" },
                                    { listItem: "Streamline customer communication processes" },
                                    { listItem: "Focus on customer retention strategies" },
                                    { listItem: "Improve team productivity and efficiency" },
                                    { listItem: "Explore new ways to leverage WhatsApp for business growth" },
                                ]}
                                className="mt-4 bg-gray-100"
                            />
                            <p className="mt-5">
                                Pickyourtrail has not just transformed its customer communication, but the entire growth trajectory by being a differential in the crowded market of
                                travel companies.
                            </p>
                        </section>
                    </div>
                </div>
                <div>
                    <div style={{ position: "sticky", top: "100px", minHeight: "510px" }} className="hidden md:block">
                        <Navbar links={navLinks} />
                    </div>
                </div>
            </section>
            <div className="max-w-6xl mx-auto">
                <section>
                    <h3 className="text-gray-900 mb-10 mt-5 text-left ml-4">Check out other customer stories</h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto gap-10 mb-20">
                        {casestudyCards.slice(0, 3)?.map((data, index) => (
                            <CasestudyCard key={index} {...data} />
                        ))}
                    </div>
                </section>
            </div>
        </NewLayout>
    );
};

export default Pickyourtrail;
